import React from 'react'
import block from 'bem-cn'

import { Icon, IconProps, IconTypes } from 'components/UIKit/Icon'

import './Loader.scss'

export type LoaderProps = {
  className?: string
  type?: Extract<IconTypes, 'spinner' | 'spinner-progress' | 'spinner-filled'>
  size?: IconProps['size']
}

const b = block('loader-spinner')

export const Loader: React.FC<LoaderProps> = ({ className, type = 'spinner-filled', size }) => (
  <Icon className={b.mix(className)} size={size} type={type as IconTypes} />
)
